"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validTransactionHash = function validTransactionHash(txHash) {
  if (typeof txHash !== 'string') {
    return false;
  }

  return /^0x([A-Fa-f0-9]{64})$/.test(txHash);
};

exports.default = validTransactionHash;